import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config/api';

const HandymanAuthContext = createContext(null);

export const HandymanAuthProvider = ({ children }) => {
  const [handyman, setHandyman] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('handyman_token'));
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem('handyman_token');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null);
    setHandyman(null);
  }, []);

  const fetchHandyman = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/handyman/me`);
      setHandyman(response.data);
    } catch (error) {
      console.error('Failed to fetch handyman:', error);
      logout();
    } finally {
      setLoading(false);
    }
  }, [logout]);

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchHandyman();
    } else {
      setLoading(false);
    }
  }, [token, fetchHandyman]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/handyman/login`, { email, password });
    const { access_token, handyman: handymanData } = response.data;
    localStorage.setItem('handyman_token', access_token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    setToken(access_token);
    setHandyman(handymanData);
    return handymanData;
  };

  return (
    <HandymanAuthContext.Provider value={{ handyman, token, loading, login, logout, isAuthenticated: !!handyman }}>
      {children}
    </HandymanAuthContext.Provider>
  );
};

export const useHandymanAuth = () => {
  const context = useContext(HandymanAuthContext);
  if (!context) {
    throw new Error('useHandymanAuth must be used within a HandymanAuthProvider');
  }
  return context;
};
